import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['finished']

  static values = { src: String }

  connect() {
    if (this.srcValue && !this.hasFinishedTarget) {
      this.#initialTimeout()
    }
  }

  finishedTargetConnected() {
    clearInterval(this.interval)
  }

  #initialTimeout() {
    setTimeout(() => {
      this.element.src = this.srcValue
      this.#startPolling()
    }, 500)
  }

  #startPolling() {
    this.interval = setInterval(() => {
      this.element.src = this.srcValue
    }, 7_000)
  }
}
